import React from "react";
import {CSpinner} from '@coreui/react'
import Api from './api';

const Loading = () => (
    <div style={{position: 'fixed', background: 'rgba(51,51,51,0.2)', width: '100%', height: '100%', left: 0, top: 0, zIndex: 1}}>
        <CSpinner style={{position: 'absolute', left: '50%', top: '50%', padding: 35}} variant="grow" />
    </div>
);

const checkAuth = () => new Promise( async (resolve, reject) => {
    try{
      await Api().get('/api/admin/user_profile');
      return resolve(true);
    }catch(error){
        return reject(false);
    }
});

export {
    Loading,
    checkAuth
};
